<template>
  <v-card class="dashboard">
    <v-card-text>{{ title }}</v-card-text>
    <v-card-title>
      <span class="text-nowrap">{{ value }}</span>
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  name: 'SummaryItem',
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.dashboard {
  padding-left: 10px;
  padding-right: 60px;
  position: relative;
  height: 100%;

  .v-card__text {
    padding-bottom: 0;
  }

  &:after {
    content: '';
    display: block;
    width: 40px;
    height: 40px;
    position: absolute;
    top: 10px;
    right: 10px;
  }

  &.tFolders:after {
    background: url(~@/assets/icons/svg/totalFolder.svg) no-repeat 0 0;
    background-size: 40px 40px;
  }

  &.tItems:after {
    background: url(~@/assets/icons/svg/totalItem.svg) no-repeat 0 0;
    background-size: 40px 40px;
  }

  &.tQTY:after {
    background: url(~@/assets/icons/svg/totalQty.svg) no-repeat 0 0;
    background-size: 40px 40px;
  }

  &.tValue:after {
    background: url(~@/assets/icons/svg/totalValue.svg) no-repeat 0 0;
    background-size: 40px 40px;
  }
}
</style>
